import { useRef, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

interface MediaModalProps {
  video: { alt: string; url: string; video?: boolean } | undefined

  thumbnail: {
    src: string | undefined
  }
  title: string | undefined
  autoPlay?: boolean
}

const Media = ({ video, thumbnail, title, autoPlay }: MediaModalProps) => {
  const [_isHovered, setIsHovered] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)

  const handleMouseEnter = () => {
    setIsHovered(true)
    videoRef.current?.play()
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
    videoRef.current?.pause()
  }
  return (
    <Box
      borderRadius={{
        all: 'abs012',
      }}
      border={{ all: { width: 's1', color: 'grey300', style: 'solid' } }}
    >
      {video ? (
        <video
          ref={videoRef}
          src={video?.url || ''}
          title={video?.alt || ''}
          loop
          muted
          onMouseOver={!autoPlay ? handleMouseEnter : undefined}
          onMouseOut={!autoPlay ? handleMouseLeave : undefined}
          style={{ borderRadius: '12px' }}
          autoPlay={autoPlay}
        />
      ) : (
        <img src={thumbnail.src} alt={title} style={{ borderRadius: '12px' }} />
      )}
    </Box>
  )
}

export default Media
